import { Step01Nome } from './steps/Step01Nome';
import { Step02Email } from './steps/Step02Email';
import { Step03Senha } from './steps/Step03Senha';
import { Step04TipoPerfil } from './steps/Step04TipoPerfil';
import { Step05Cargo } from './steps/Step05Cargo';
import { Step06Empresa } from './steps/Step06Empresa';
import { Step07Segmento } from './steps/Step07Segmento';
import { Step08Estado } from './steps/Step08Estado';
import { Step09Faturamento } from './steps/Step09Faturamento';
import { Step10TamanhoTime } from './steps/Step10TamanhoTime';
import { Step11FrequenciaNetworking } from './steps/Step11FrequenciaNetworking';
import { Step12TagsBusca } from './steps/Step12TagsBusca';
import { Step13TagsOferta } from './steps/Step13TagsOferta';
import { Step14Gargalo } from './steps/Step14Gargalo';
import { Step15DiagnosticoFase } from './steps/Step15DiagnosticoFase';
import { Step16ConsentSponsor } from './steps/Step16ConsentSponsor';
import type { SignupStep } from './types';

export const signupSteps: ReadonlyArray<SignupStep> = [
  {
    id: 'nome',
    title: 'Qual é o seu nome completo?',
    subtitle: 'Em menos de 1 minuto você está conectado ao evento.',
    fields: ['nome'],
    Component: Step01Nome,
  },
  {
    id: 'email',
    title: 'Qual é o seu melhor email?',
    subtitle: 'É por aqui que vamos te avisar dos matches.',
    fields: ['email'],
    Component: Step02Email,
  },
  {
    id: 'senha',
    title: 'Crie uma senha segura',
    subtitle: 'Use ao menos 8 caracteres, 1 maiúscula, 1 número e 1 caractere especial.',
    fields: ['senha'],
    Component: Step03Senha,
  },
  {
    id: 'tipoPerfil',
    title: 'Como você se identifica?',
    subtitle: 'Isso ajuda o algoritmo a calibrar suas conexões.',
    fields: ['tipoPerfil'],
    Component: Step04TipoPerfil,
  },
  {
    id: 'cargo',
    title: 'Qual é o seu cargo atual?',
    fields: ['cargo'],
    Component: Step05Cargo,
  },
  {
    id: 'empresa',
    title: 'Em qual empresa você atua?',
    fields: ['empresa'],
    Component: Step06Empresa,
  },
  {
    id: 'segmento',
    title: 'Em qual segmento ela opera?',
    subtitle: 'Indústria, mercado ou área de atuação principal.',
    fields: ['segmento'],
    Component: Step07Segmento,
  },
  {
    id: 'estado',
    title: 'De qual estado você é?',
    subtitle: 'Apenas a sigla, ex.: MS, SP, RJ.',
    fields: ['estado'],
    Component: Step08Estado,
  },
  {
    id: 'faturamento',
    title: 'Qual o faturamento anual?',
    subtitle: 'Sem julgamento. Usamos para calibrar conexões compatíveis.',
    fields: ['faturamento'],
    Component: Step09Faturamento,
  },
  {
    id: 'tamanhoTime',
    title: 'Quantas pessoas no time?',
    fields: ['tamanhoTime'],
    Component: Step10TamanhoTime,
  },
  {
    id: 'frequenciaNetworking',
    title: 'Com que frequência você faz networking?',
    fields: ['frequenciaNetworking'],
    Component: Step11FrequenciaNetworking,
  },
  {
    id: 'tagsBusca',
    title: 'O que você BUSCA neste evento?',
    subtitle: 'Escolha até 3 áreas. Quanto mais preciso, melhor.',
    fields: ['tagsBuscaIds'],
    Component: Step12TagsBusca,
  },
  {
    id: 'tagsOferta',
    title: 'O que você OFERECE / pode entregar?',
    subtitle: 'Escolha até 3 áreas em que você agrega valor.',
    fields: ['tagsOfertaIds'],
    Component: Step13TagsOferta,
  },
  {
    id: 'gargalo',
    title: 'Qual é o seu maior gargalo hoje?',
    subtitle: 'Detalhe ajuda a IA a sugerir os contatos certos.',
    fields: ['gargalo'],
    Component: Step14Gargalo,
  },
  {
    id: 'diagnosticoFase',
    title: 'Em qual fase você está?',
    fields: ['diagnosticoFase'],
    Component: Step15DiagnosticoFase,
  },
  {
    id: 'consentSponsor',
    title: 'Pronto para entrar no Match',
    subtitle: 'Última etapa: nossos patrocinadores podem te apresentar oportunidades.',
    fields: ['consentSponsor'],
    Component: Step16ConsentSponsor,
  },
] as const;
